import React, { useEffect, useState } from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import HorStepper from '../Steppers/HorStepper';
import AddFormInfoComponent from '../StepComponents/AddFormInfoComponent';
import AddFormProductsComponent from '../StepComponents/AddFormProductsComponent';
import AddFormFreeClausesComponent from '../StepComponents/AddFormFreeClausesComponent';
import AddFormResultComponent from '../StepComponents/AddFormResultComponent';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import { numberRangeCode } from '../../Config/constants';

export default function AddPage(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [steps, setSteps] = useState([]);
    const [showFinishDialog, setShowFinishDialog] = useState(false)

    useEffect(() => {

        if (!props.addPage.horStep) {
            props.actions.setHorstep(1);
        }

        let stepsArray = [
            { "id": 1, "key": 1, "name": "General info", "isComplete": false, "isInProgress": true, "hasPrevious": false, "hasNext": true, "formComponentName": "addFormInfoComponent" },
            { "id": 2, "key": 2, "name": "Products", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "addFormProductsComponent" },
            { "id": 3, "key": 3, "name": "Free clauses", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "addFormFreeClausesComponent" },
            { "id": 4, "key": 4, "name": "Contract", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": false, "formComponentName": "addFormResultComponent" }];
        stepsArray.map((x) => {
            if (x.id < props.addPage.horStep) {
                x.isComplete = true;
                x.isInProgress = false;
            } else if (x.id == props.addPage.horStep) {
                x.isInProgress = true;
                x.isComplete = false;
            } else {
                x.isComplete = false;
                x.isInProgress = false;
            }
        });

        let ref = '';
        if (props.addPage.editcontractmode) {
            ref = props.addPage.externalReference;
            props.actions.setExternalRef(ref);

        } else {
            Promise.all([
                dataService.getPurchaseOrders(),
                dataService.getNumberRanges()
            ]).then((results) => {

                let purchaseOrders = results[0].Results
                let numberRanges = results[1].Results

                ref = CreateExternalReference(purchaseOrders, numberRanges);
                props.actions.setExternalRef(ref);

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
        }

        if (JSON.stringify(steps) !== JSON.stringify(stepsArray)) {
            setSteps(stepsArray)
        }

    }, [props.addPage.horStep])

    const CreateExternalReference = (purchaseOrders, numberRanges) => {
        let range = numberRanges.find(obj => { return obj.Code === numberRangeCode });
        let num = AddLeadingZeros(CalculateCurrentNumber(numberRanges), 6);
        let externalRef = range ? range.Prefix + num : "Dev" + num;
        return externalRef;
    }

    const AddLeadingZeros = (num, size) => {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    const CalculateCurrentNumber = (numberRanges) => {

        let id = props.addPage.externalReferenceID
        if (props.addPage.externalReferenceCalculated) {
            return id;
        }

        //set calculated
        props.actions.setExternalRefCalculated(true);

        //check if numberrange has a higher value
        let range = numberRanges.find(obj => { return obj.Code === numberRangeCode });

        id = range.CurrentNumber + 1

        dataService.increaseNumberRange().then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
        props.actions.SetExternalRefID(id)
        return id;       
    }

    const SetPrevious = () => {
        let newstep = props.addPage.horStep - 1;
        props.actions.setHorstep(newstep);
    }

    const SetNext = () => {
        if (props.addPage.horStep === steps.length) {
            props.actions.SetDialogState(true);

            // this.setState((state) => ({ showFinishDialog: true }));
        } else {
            let newstep = props.addPage.horStep + 1;
            props.actions.setHorstep(newstep);
        }
    }

    return <div className={classes.addPageContainer}>
        {steps ?
            <React.Fragment> <HorStepper {...props} actions={props.actions} steps={steps}></HorStepper>
                {
                    steps.map((x) => {
                        if (x.id === props.addPage.horStep) {
                            switch (x.formComponentName) {
                                case "addFormInfoComponent":
                                    return (
                                        <AddFormInfoComponent actions={props.actions} {...props} key="info" hasPrevious={x.hasPrevious} hasNext={x.hasNext} SetPrevious={SetPrevious} SetNext={SetNext}></AddFormInfoComponent>)
                                case "addFormProductsComponent":
                                    return (
                                        <AddFormProductsComponent actions={props.actions} {...props} key="product" hasPrevious={x.hasPrevious} hasNext={x.hasNext} SetPrevious={SetPrevious} SetNext={SetNext}></AddFormProductsComponent>)
                                case "addFormFreeClausesComponent":
                                    return (
                                        <AddFormFreeClausesComponent actions={props.actions} {...props} key="clauses" hasPrevious={x.hasPrevious} hasNext={x.hasNext} SetPrevious={SetPrevious} SetNext={SetNext}></AddFormFreeClausesComponent>)
                                case "addFormResultComponent":
                                    return (
                                        <AddFormResultComponent actions={props.actions} {...props} key="result" hasPrevious={x.hasPrevious} hasNext={x.hasNext} SetPrevious={SetPrevious} SetNext={SetNext} showDialog={showFinishDialog}></AddFormResultComponent>)
                            }
                        }
                    })
                }</React.Fragment>
            :
            <React.Fragment></React.Fragment>
        }

    </div>
}

const useStyles = makeStyles({

});